import React, {useState, useEffect} from 'react';

import EmailInputComponent from '../common/genericComponents/redesign/emailInputComponent/emailInputComponent';
import FormComponentV2 from '../common/genericComponents/redesign/formComponentV2/formComponentV2';
import InputComponentV2 from '../common/genericComponents/redesign/inputComponentV2/inputComponentV2';
import SeparatorComponent from '../common/genericComponents/separatorComponent/separatorComponent';

import './sendMailComponent.css';

const SendMailComponentRender = (props) => {
  const [isSendBtnClicked, setIsSendBtnClicked] = useState(false);
  const [isMessageValid, setIsMessageValid] = useState(true);
  const [isSubjectValid, setIsSubjectValid] = useState(true);
  const [showShakeAnim, setShowShakeAnim] = useState(false);

  useEffect(() => {
    if (props.messageToSend === null) {
      setIsMessageValid(true);
    } else {
      if (props.messageToSend.trim().length === 0) {
        setIsMessageValid(false);
      } else setIsMessageValid(true);
    }
  }, [props.messageToSend]);

  useEffect(() => {
    if (props.emailSubject.trim().length === 0) {
      setIsSubjectValid(false);
    } else setIsSubjectValid(true);
  }, [props.emailSubject]);

  const onCancel = () => {
    props.handleCancel(true);
  };

  const onSend = () => {
    setIsSendBtnClicked(true);
    if (
      !props.messageToSend ||
      props.messageToSend.trim().length === 0 ||
      !props.emailSubject ||
      props.emailSubject.trim().length === 0 ||
      !props.areAllClientEmailsValid
    ) {
      if (!props.messageToSend || props.messageToSend.trim().length === 0) {
        setIsMessageValid(false);
      }
      if (!props.emailSubject || props.emailSubject.trim().length === 0) {
        setIsSubjectValid(false);
      }
      setShowShakeAnim(true);
    } else {
      props.handleSubmit();
    }
  };

  const onEmailsChanged = (id, value, areAllClientEmailsValid) => {
    props.handleOfflineClientEmails(value, areAllClientEmailsValid);
  };

  return (
    <div className="et-send-mail-container">
      <FormComponentV2
        isRightBtnDisabled={
          isSendBtnClicked &&
          (!props.messageToSend ||
            props.messageToSend.trim().length === 0 ||
            !props.emailSubject ||
            props.emailSubject.trim().length === 0)
        }
        showShakeAnim={showShakeAnim}
        showRightBtnSpinner={props.showEmailSpinner}
        formSubTitle={
          props.isEmailBtnFlow
            ? null
            : 'Your message did not reach the customer because they are no longer browsing the site. Send the message by email instead:'
        }
        formTitle={
          props.isEmailBtnFlow ? 'Send message via email' : 'Send as email?'
        }
        leftBtnTxt="Close"
        rightBtnTxt="Send"
        onLeftBtnClicked={onCancel}
        onRightBtnClicked={onSend}>
        <SeparatorComponent />
        <EmailInputComponent
          id="semc_emails"
          showCustomError={isSendBtnClicked && !props.areAllClientEmailsValid}
          initialEmails={props.offlineClientEmails}
          errorMessage="Please enter valid email(s)"
          placeholder="Enter email here"
          titleTxt="To:"
          onEmailsChanged={onEmailsChanged}
        />
        <SeparatorComponent />
        <InputComponentV2
          id="semc_subject"
          noWaitOnInput={true}
          defaultValue={props.emailSubject}
          errorMessage="Please provide valid subject"
          placeholder="Subject"
          titleTxt="Subject:"
          onChange={props.handleSubjectChange}
          showCustomError={!isSubjectValid}
        />
        <SeparatorComponent />
        <InputComponentV2
          id="semc_comment"
          needEventObject
          noWaitOnInput={true}
          defaultValue={props.messageToSend || ''}
          errorMessage="Please provide valid content"
          inputType="textarea"
          maxLength={2000}
          placeholder="Say something…"
          titleTxt="Content:"
          onChange={props.handleContentChange}
          showCustomError={!isMessageValid}
          hideCharacterCount={true}
        />
        <SeparatorComponent />
      </FormComponentV2>
    </div>
  );
};

export default SendMailComponentRender;
